import React from "react";
import {LINKS, PAGES} from "./constants";
import { isDesktop } from "./utils";
import Selectors from "./selectors";
import { connect } from "react-redux";
import Header from "./components/commons/Header";
import { setIsDesktopAction, updateCurrentPageAction } from "./state/registration";
import Footer from "./components/commons/Footer";
import FirstStep from "./components/FirstStep";
import SecondStep from "./components/SecondStep";
import SmsStep from "./components/SMSStep";
import CompletedStep from "./components/CompletedStep";
import ActivationSuccess from "./components/ActivationSuccess";
import ActivationError from "./components/ActivationError";

const stateToProps = (state) => ({
    currentPage: Selectors.getCurrentPage(state),
    modalOpen: Selectors.isModalOpen(state),
    isDesktop: Selectors.isDesktop(state)
});

const actionsToProps = (dispatch) => ({
    setIsDesktop: (data) => dispatch(setIsDesktopAction(data)),
    updateCurrentPage: (data) => dispatch(updateCurrentPageAction(data)),
});

const RegistrationApp = (props) => {

    props.setIsDesktop(isDesktop());

    const goBackClick = () => {
        if (props.currentPage === PAGES.SECOND_STEP) {
            props.updateCurrentPage(PAGES.FIRST_STEP);
        }

        if (props.currentPage === PAGES.SMS_STEP) {
            props.updateCurrentPage(PAGES.SECOND_STEP);
        }
    };

    const renderCurrentPage = () => {
        if (location.pathname.toLowerCase() === PAGES.SUCCESS) {
            return (<ActivationSuccess />);
        } else if (location.pathname.toLowerCase() === PAGES.ERROR) {
            return <ActivationError />;
        } else {
            switch (props.currentPage) {
                case PAGES.FIRST_STEP:
                    return (<FirstStep/>);
                case PAGES.SECOND_STEP:
                    return (<SecondStep/>);
                case PAGES.SMS_STEP:
                    return (<SmsStep/>);
                case PAGES.COMPLETE_STEP:
                    return (<CompletedStep/>);
                default:
                    return (<FirstStep/>);
            }
        }
    };

    return (
        <div className={props.modalOpen === true ? 'app modal-open' : 'app'}>
            <div id="wrapper" className="wrapper">
                <Header />

                <main>
                    <div className="container">
                        <div className="registration">
                            <div className="registration-main">
                                <div className="registration-main__head txt-c">
                                    {(props.currentPage !== PAGES.COMPLETE_STEP && ![PAGES.SUCCESS, PAGES.ERROR].includes(location.pathname.toLowerCase()))
                                        && (
                                            <div className="registration-user_info">
                                                <span>
                                                  Already have a Bet9ja account?
                                                  <span className="registration__link ml5" title="Sign in">
                                                      <a href={LINKS.home}><strong>Sign in</strong></a>
                                                  </span>
                                                </span>
                                            </div>
                                        )}

                                    {(props.isDesktop && props.currentPage !== PAGES.FIRST_STEP && props.currentPage !== PAGES.COMPLETE_STEP)
                                        && (
                                            <div className="txt-l mb10 " role="button" tabIndex="0" onClick={() => goBackClick()}>
                                                <span className="registration__link" title="Go Back">Go Back</span>
                                            </div>
                                        )}

                                    {![PAGES.SUCCESS, PAGES.ERROR].includes(location.pathname.toLowerCase()) &&
                                        (<h1 className="registration-main__h1">Open Account</h1>)
                                    }
                                </div>

                                {![PAGES.SUCCESS, PAGES.ERROR].includes(location.pathname.toLowerCase()) && (
                                    <div className="steps">
                                        <div className={`step ${props.currentPage !== PAGES.FIRST_STEP ? 'step--prev' : ''}`}>
                                            <div className="step__check"/>
                                            <div className="step__label">Step 1</div>
                                        </div>
                                        <div className={`step ${props.currentPage !== PAGES.SECOND_STEP ? 'step--prev' : ''}`}>
                                            <div className="step__check"/>
                                            <div className="step__label">Step 2</div>
                                        </div>
                                        <div className={`step ${props.currentPage !== PAGES.SMS_STEP ? 'step--prev' : ''}`}>
                                            <div className="step__check"/>
                                            <div className="step__label">Step 3</div>
                                        </div>
                                    </div>
                                )}

                                {renderCurrentPage()}

                            </div>
                            <aside className="registration-sidebar">
                                <div className="registration-sidebar__intro">
                                    Win up to<span className="txt-white">₦1 billion</span>
                                </div>
                                <a href="" className="registration-sidebar__img-s"></a>
                                <div className="registration-sidebar__img-l"></div>
                            </aside>
                        </div>
                    </div>
                </main>

                <Footer/>
            </div>
        </div>
    )
}

export default connect(
    stateToProps,
    actionsToProps
)(RegistrationApp);

